import { useRoleBasedAccess } from "./use-role-based-access";

/**
 * Single source of truth for role-based UI flags.
 * Partner status is derived from the partner record, not a separate role,
 * so an organisation user can also be a partner without multi-role issues.
 */
export const useRoleFlags = () => {
  const { userRole, isPartner } = useRoleBasedAccess();

  const isSuperuser = userRole === 'superuser';
  const isAdmin = userRole === 'admin';
  const isStandard = userRole === 'standard';
  const isEditor = userRole === 'editor';
  const isInternalStaff = userRole === 'internal_staff';
  const isAdvisor = userRole === 'advisor';
  const isProduction = userRole === 'production';
  const isArchived = userRole === 'archived';

  return {
    role: userRole,
    isSuperuser,
    isAdmin,
    isPartner,
    isStandard,
    isEditor,
    isInternalStaff,
    isAdvisor,
    isProduction,
    isArchived,
    /** True when the user should only see Demo devices in device views. */
    isDemoOnly: isInternalStaff || isAdvisor,
    /** True when the user should see the Superuser sidebar group + CRM. */
    hasSuperuserSurface: isSuperuser || isInternalStaff,
    /** True when the user should see the Business Performance group. */
    hasBusinessPerformance: isSuperuser || isAdvisor,
  };
};
